import React from "react";
import { Link } from "react-router-dom";
import { useOpenState } from "../contexts/OpenContext";

const Sidebar = () => {
  const { state, dispatch } = useOpenState();
  return (
    <div
      className={`top-0 -left-[100vw] w-[100vw] bg-[#00947d] fixed h-full ease-in-out duration-300 z-10 ${
        state.toggle ? "translate-x-full" : "translate-x-0"
      }`}
    >
      <div className="flex flex-col justify-center px-6 pt-[90px] text-lg text-gray-100 z-20">
        {state.menu.map((el) => {
          return (
            <Link
              key={el.id}
              to={el.id}
              className={
                el.id === state.selected_menu ? "border-b-2 pt-6" : "pt-6"
              }
              onClick={() => {
                dispatch({ type: "CHANGE_TOGGLE", data: false });
                dispatch({
                  type: "SET_PUBLIC_DATA",
                  data: { selected_menu: el.id },
                });
              }}
            >
              {el.category_short}
            </Link>
          );
        })}
        {state.loggedIn ? (
          <Link
            to="/admin"
            className="pt-6"
            onClick={() => {
              dispatch({ type: "CHANGE_TOGGLE", data: false });
            }}
          >
            Админ
          </Link>
        ) : (
          <a
            href="/"
            className="pt-6"
            onClick={() => {
              dispatch({ type: "CHANGE_TOGGLE", data: false });
            }}
          >
            Нэвтрэх
          </a>
        )}
      </div>
    </div>
  );
};

export default React.memo(Sidebar);
